import styled from 'styled-components';
import { mobileLarge } from '../../styles/mediaqueries'

import { whiteColor, borderColor, textAlt, brandColor } from '../../styles/variables';


const getRadioCircleStyle = () => {
  return {
    content: "",
    borderRadius: "50%",
    transition: "all .3s ease",
    transitionProperty: "transform, border-color",
    width: "16px",
    height: "16px",
    border: "1px solid",
    borderColor: borderColor,
    margin: "0 12px 0 22px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    '&:after': {
      position: "absolute",
      content: "''",
      borderRadius: "50%",
      transition: "all .3s ease",
      transitionProperty: "transform, border-color",
      width: "6px",
      height: "6px",
      transform: "scale(0)",
      background: whiteColor
    }
  }
}


const getRadioContainerStyle = () => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    cursor: "pointer",
    width: "450px",
    border: "1px solid",
    borderColor: borderColor,
    padding: "38px 0",
    marginBottom: "20px",
    borderRadius: "4px",
    position: "relative",


    [mobileLarge]: {
      width: "335px",
      marginBottom: "15px",

      img: {
        '&:last-child': {
          top: '0'
        }
      }
    },

    img: {
      position: "absolute",
      right: "15px",
      height: "95px",

      [mobileLarge]: {
        right: "0",
      }
    }
  }
}

const getRadioSubLabelStyle = () => {
  return {
    fontWeight: 300,
    color: textAlt,
    fontSize: "14px",
    lineHeight: "20px",
    width: "270px",
    margin: "10px 0 0 50px",

    [mobileLarge]: {
      width: "190px"
    }

  }
}

const getRadioLabelStyle = ({ isChecked }) => {

  return {
    color: brandColor,
    fontWeight: isChecked ? 400 : 300,
    fontSize: "16px",
    lineHeight: "24px",
    [mobileLarge]: {
      fontSize: "15px"
    }
  }
}

const getRadioSubContainer = () => {
  return {
    display: "flex",
    alignItems: "center"
  }
}


export const StyledRadioCircle = styled.div(getRadioCircleStyle);
export const StyledRadioContainer = styled.label(getRadioContainerStyle)
export const StyledRadioSubLabel = styled.div(getRadioSubLabelStyle)
export const StyledRadioLabel = styled.div(getRadioLabelStyle)
export const StyledRadioSubContainer = styled.div(getRadioSubContainer)

// Need to be here because of checked trick
export const StyledRadioInput = styled.input`
  display: none;
  
  &:checked +  ${StyledRadioContainer} {
        border-color: #2D2E2C;

        ${StyledRadioLabel} {
          color: ${brandColor}
        }

        ${StyledRadioSubLabel} {
          color: ${textAlt}
        }

        ${StyledRadioCircle} {
        border-color: #2D2E2C;
        background-color: #2D2E2C;

        &:after {
          transform: scale(1);
        }
    }
    }
`;


// brandColor










